import { render, staticRenderFns } from "./ClientiFilters.vue?vue&type=template&id=735083c8&scoped=true"
import script from "./ClientiFilters.vue?vue&type=script&lang=js"
export * from "./ClientiFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735083c8",
  null
  
)

export default component.exports